import { Link, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";

const links = [
  { label: "Home", href: "/#top" },
  { label: "Our Story", href: "/#story" },
  { label: "Services", href: "/#services" },
  { label: "Location", href: "/#location" },
  { label: "Contact", href: "/#contact" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-navbar"
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-300 ${
        scrolled ? "bg-[#0B0B0B]/85 backdrop-blur-xl border-b border-[rgba(184,147,90,0.15)]" : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-5 md:px-10 flex items-center justify-between h-16 md:h-20">
        <Link to="/" data-testid="nav-logo" className="flex items-center gap-3 group">
          <span className="serif text-[#F7F3EC] text-xl md:text-2xl tracking-[0.35em]">NOIR</span>
          <span className="w-6 h-px bg-[#B8935A]" />
          <span className="serif text-[#F7F3EC] text-xl md:text-2xl tracking-[0.35em]">NAILS</span>
        </Link>

        <nav className="hidden md:flex items-center gap-9">
          {links.map((l) => (
            <a
              key={l.label}
              href={l.href}
              data-testid={`nav-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
              className="text-[0.68rem] tracking-[0.28em] uppercase text-[#F7F3EC] hover:text-[#B8935A] transition-colors"
            >
              {l.label}
            </a>
          ))}
          <button
            data-testid="nav-book-cta"
            onClick={() => navigate("/book")}
            className="btn-gold"
          >
            Book Now
          </button>
        </nav>

        <button
          data-testid="nav-mobile-toggle"
          onClick={() => setOpen((o) => !o)}
          className="md:hidden text-[#F7F3EC] p-2"
          aria-label="Menu"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div className="md:hidden bg-[#0B0B0B] border-t border-[rgba(184,147,90,0.15)]">
          <div className="px-6 py-8 flex flex-col gap-6">
            {links.map((l) => (
              <a
                key={l.label}
                href={l.href}
                onClick={() => setOpen(false)}
                data-testid={`nav-mobile-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                className="text-sm tracking-[0.28em] uppercase text-[#F7F3EC]"
              >
                {l.label}
              </a>
            ))}
            <button
              onClick={() => { setOpen(false); navigate("/book"); }}
              data-testid="nav-mobile-book-cta"
              className="btn-primary w-full"
            >
              Book Appointment
            </button>
          </div>
        </div>
      )}
    </header>
  );
}
